import React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import LandingPage from '../LandingPage';

/**
 * HomeGate — `/` route.
 *  - Logged-in  → redirect /app
 *  - Logged-out → LandingPage with onSignup/onLogin wired to navigate /login
 *
 * For "logged in but want to view landing" → use `/home` route (see HomeLandingRoute).
 */
const HomeGate: React.FC = () => {
  const { user, isLoading } = useAuth();
  const navigate = useNavigate();

  if (isLoading) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <svg className="w-8 h-8 text-indigo-500 animate-spin" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
          </svg>
        </div>
      </div>
    );
  }

  if (user) {
    return <Navigate to="/app" replace />;
  }

  return (
    <LandingPage
      onSignup={() => navigate('/login')}
      onLogin={() => navigate('/login')}
    />
  );
};

export default HomeGate;
